"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const react_router_dom_1 = require("react-router-dom");
const arrow_back_svg_1 = __importDefault(require("../../svg/arrow-back.svg"));
const useStyles = (0, react_jss_1.createUseStyles)({
    back: {
        position: "absolute",
        top: 10,
        right: 10,
        width: 90,
        height: 90,
        cursor: "pointer",
        outline: "none",
        border: "none",
        "&:focus > path:first-child, &:focus-visible > path:first-child": {
            fill: "#155755",
        },
    },
});
const ArrowBack = () => {
    const classes = useStyles();
    const navigate = (0, react_router_dom_1.useNavigate)();
    return (react_1.default.createElement(arrow_back_svg_1.default, { className: classes.back, tabIndex: 0, onClick: () => navigate(-1) }));
};
exports.default = ArrowBack;
